import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function AudienceSection() {
  const {
    ref,
    isVisible
  } = useScrollReveal();
  return <section className="relative py-24 px-6 z-10 bg-night-900" data-id="element-3">
      <div ref={ref} className={`max-w-5xl mx-auto section-reveal ${isVisible ? 'visible' : ''}`} data-id="element-4">
        <div className="grid md:grid-cols-2 gap-8" data-id="element-5">
          {/* Who this is for */}
          <div className="glass-card p-8 md:p-10 rounded-3xl border-t-4 border-t-gold-500" data-id="element-6">
            <h3 className="text-2xl font-heading font-bold text-cream-100 mb-8 flex items-center" data-id="element-7">
              Esto es para ti si...
            </h3>
            <ul className="space-y-6" data-id="element-8">
              <li className="flex items-start" data-id="element-9">
                <div className="flex-shrink-0 mt-1" data-id="element-10">
                  <CheckIcon className="w-6 h-6 text-gold-400" data-id="element-11" />
                </div>
                <p className="ml-4 text-cream-200 text-lg" data-id="element-12">
                  Eres una mujer de 50+ que sufre de "ruido mental" al
                  acostarse.
                </p>
              </li>
              <li className="flex items-start" data-id="element-13">
                <div className="flex-shrink-0 mt-1" data-id="element-14">
                  <CheckIcon className="w-6 h-6 text-gold-400" data-id="element-15" />
                </div>
                <p className="ml-4 text-cream-200 text-lg" data-id="element-16">
                  Despiertas a las 3:00 AM y no puedes volver a dormir.
                </p>
              </li>
              <li className="flex items-start" data-id="element-17">
                <div className="flex-shrink-0 mt-1" data-id="element-18">
                  <CheckIcon className="w-6 h-6 text-gold-400" data-id="element-19" />
                </div>
                <p className="ml-4 text-cream-200 text-lg" data-id="element-20">
                  Buscas una solución natural, rápida y basada en la biología,
                  no en la magia.
                </p>
              </li>
            </ul>
          </div>

          {/* Who this is NOT for */}
          <div className="glass-card p-8 md:p-10 rounded-3xl border-t-4 border-t-night-800 opacity-80" data-id="element-21">
            <h3 className="text-2xl font-heading font-bold text-cream-200/70 mb-8 flex items-center" data-id="element-22">
              Esto NO es para ti si...
            </h3>
            <ul className="space-y-6" data-id="element-23">
              <li className="flex items-start" data-id="element-24">
                <div className="flex-shrink-0 mt-1" data-id="element-25">
                  <XIcon className="w-6 h-6 text-cream-200/40" data-id="element-26" />
                </div>
                <p className="ml-4 text-cream-200/70 text-lg" data-id="element-27">
                  Buscas consejos médicos o diagnósticos clínicos.
                </p>
              </li>
              <li className="flex items-start" data-id="element-28">
                <div className="flex-shrink-0 mt-1" data-id="element-29">
                  <XIcon className="w-6 h-6 text-cream-200/40" data-id="element-30" />
                </div>
                <p className="ml-4 text-cream-200/70 text-lg" data-id="element-31">
                  No estás dispuesta a dedicar 10 minutos a un ritual de paz.
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}